var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 95,
    viewBox: "0 0 93 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Yellow STAR"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.8873 81.1159L46.6743 57.0221L47.1259 55.4187L47.8902 56.8989L59.761 79.8901L65.0017 77.1842L53.1309 54.193L52.3667 52.7128L53.9355 53.273L77.5089 61.6912L79.1851 55.7407L55.5269 47.2923L54.1029 46.7837L55.4465 46.09L76.8776 35.0247L73.9372 29.3299L52.5061 40.3951L51.1625 41.0889L51.5725 39.6334L58.3838 15.453L52.5618 13.374L45.7749 37.4677L45.3232 39.0711L44.559 37.5909L32.6882 14.5997L27.4474 17.3056L39.3182 40.2968L40.0825 41.777L38.5137 41.2168L14.9403 32.7987L13.2641 38.7492L36.9223 47.1976L38.3463 47.7061L37.0027 48.3998L15.5716 59.4651L18.5119 65.16L39.9431 54.0947L41.2867 53.401L40.8767 54.8564L34.0653 79.0368L39.8873 81.1159Z",
    fill: "#FFCC33",
    stroke: "black",
    strokeWidth: 1.31373
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/YellowSTAR.518a378e00cc9ed1bbe1dfd8462fb98f.svg";
export { ForwardRef as ReactComponent };